import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import CssBaseline from '@material-ui/core/CssBaseline';
import { StylesProvider, ThemeProvider } from '@material-ui/styles';
import LanguageProvider from './providers/LanguageProvider/languageProvider';
import FsmProvider from './fsm/Provider/provider';
import { ImagesProvider } from './providers/ImagesContext/imagesContext';
import { CalendarProvider } from './providers/CalendarContext/calendarContext';
import App from './components/App/App';

export function appRenderer(mountNode, store, history, theme, machine, config, imageFactory, dateFnsLocaleData) {
  return messages => {
    ReactDOM.render(
      <FsmProvider machine={machine}>
        <ImagesProvider value={imageFactory}>
          <CalendarProvider value={config.spareDays}>
            <StylesProvider injectFirst>
              <Provider store={store}>
                <LanguageProvider messages={messages}>
                  <ThemeProvider theme={theme}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={dateFnsLocaleData}>
                      <Router history={history}>
                        <CssBaseline />
                        <App store={store} />
                      </Router>
                    </MuiPickersUtilsProvider>
                  </ThemeProvider>
                </LanguageProvider>
              </Provider>
            </StylesProvider>
          </CalendarProvider>
        </ImagesProvider>
      </FsmProvider>,
      mountNode
    );
  };
}
